import { Carousel } from '@/src/packages/components/ui/Carousel';
import { SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import {
  ZoomableImageProvider,
  ZoomableImageWrapper,
} from '@/src/packages/components/ui/ZoomableImage';
import { Asset } from 'contentful';

export const ProductLookbook = ({ images }: { images: Asset[] }) => {
  if (images.length === 0) return <></>;

  return (
    <ZoomableImageProvider images={images}>
      <Carousel slidesPerView={1} isFlush>
        {images.map((image, i) => {
          return (
            <SwiperSlide key={i}>
              <ZoomableImageWrapper className="aspect-[4/3] lg:aspect-video">
                <Image
                  alt=""
                  src={image.fields.file.url}
                  fill
                  className="object-cover"
                  sizes="100vw"
                />
              </ZoomableImageWrapper>
            </SwiperSlide>
          );
        })}
      </Carousel>
    </ZoomableImageProvider>
  );
};
